function changeClass(selector, target) {
    $(selector).each(function(index){
        if ($(this).data('target') == target) {
            $(this).addClass('active');
        }
        else {
            $(this).removeClass('active');
        }
    }); 
}

$(document).ready(function(){
    $('body').on('click', '.fancy_image_text_titles h2', function(e){
        let target = $(this).data('target');
        changeClass('.fancy_image_text_slide', target);
        changeClass('.fancy_image_text_titles h2', target);
        changeClass('.fancy_image_text_titles p', target);
        changeClass('.fancy_image_text_dot', target);
    });
    $('body').on('click', '.fancy_image_text_dot', function(e){
        let target = $(this).data('target');
        changeClass('.fancy_image_text_slide', target);
        changeClass('.fancy_image_text_titles h2', target);
        changeClass('.fancy_image_text_titles p', target);
        changeClass('.fancy_image_text_dot', target);
    });
});